
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/old-home",
      function () {
        return require("private-next-pages/old-home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/old-home"])
      });
    }
  